module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    attrs: {
      "id": "body_bg"
    }
  }, [_c('div', {
    attrs: {
      "id": "site_bg"
    }
  }, [_c('div', {
    attrs: {
      "id": "site_bg_2"
    }
  }, [_c('div', {
    attrs: {
      "id": "site"
    }
  }, [_c('div', {
    attrs: {
      "id": "nonFooter"
    }
  }, [_c('div', {
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    attrs: {
      "id": "header_box"
    }
  }, [_c('div', {
    staticClass: "illustration"
  }, [_c('div', {
    attrs: {
      "id": "logozone"
    }
  }, [_c('h2', {
    attrs: {
      "id": "logo"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('span', [_vm._v("Salon Jája")])])], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../static/img/logo.jpg"),
      "width": "770",
      "height": "266"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "cleaner"
  }), _vm._v(" "), _c('app-menu'), _vm._v(" "), _c('div', {
    staticClass: "cleaner"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "main"
    }
  }, [_c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('router-view')], 1), _vm._v(" "), _c('app-sidebar'), _vm._v(" "), _c('hr', {
    staticClass: "cleaner"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "cleaner"
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "footer"
    }
  })])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    attrs: {
      "id": "moto"
    }
  }, [_c('span', {
    staticClass: "rbcNoStyleSpan",
    attrs: {
      "id": "rbcCompanySlogan"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5930af97"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 78
// module chunks = 0